import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly MAX_CHILD_TITLES = 2;
  private readonly APP_TITLE = 'Delen';

  private readonly title = inject(Title);

  updateTitle(snapshot: RouterStateSnapshot): void {
    // Get titles from all children
    const childTitles = this.getChildTitles(snapshot.root);
    const title: string = childTitles.reverse().splice(0, this.MAX_CHILD_TITLES).join(' - ');

    if (title.length === 0) return this.title.setTitle(this.APP_TITLE);

    this.title.setTitle(`${title} • ${this.APP_TITLE}`);
  }

  private getChildTitles(route: ActivatedRouteSnapshot): string[] {
    const titles: string[] = [];

    // Check if current route has a title
    if (route.title) {
      titles.push(route.title);
    } else if (route.data?.title) {
      titles.push(route.data.title);
    }

    // Recursively get titles from children
    if (route.children) {
      for (const child of route.children) {
        titles.push(...this.getChildTitles(child));
      }
    }

    return titles;
  }
}
